import createDuck, { createAction, createThunk } from "../utils/actions";
import axios from "../net/axios";
import config from "../config";
let baseUrl = config.api.baseUrl;
const newActions = {
  test: (name) => createAction("NAME", name),
};

const newReducers = {
  NAME: (state, action) => {
    const nState = { data: action.payload, loading: false, error: null };
    return { ...state, ...nState };
  },
};

const duck = createDuck("GET_AUSENCIAS", newActions, newReducers);

const getAusenciasThunk = (localId, page, limit, profesional=null, dia=null) => {

  let url = `${baseUrl}/getAusencias`

  const data = {
    localId,
    page,
    limit,
    profesional,
    dia,
  }
  return createThunk(axios, "post", duck.actions, url, data);
};


const createAusenciaDuck = createDuck("ADD_AUSENCIA", newActions, newReducers);

const createAusenciaThunk = (data) => {
  let url = `${baseUrl}/addAusencia`;
  return createThunk(axios, "post", createAusenciaDuck.actions, url, data);
};

const deleteAusenciaDuck = createDuck("DELETE_AUSENCIA", newActions, newReducers);

const deleteAusenciaThunk = (data) => {
  let url = `${baseUrl}/deleteAusencia`;
  return createThunk(axios, "post", deleteAusenciaDuck.actions, url, data);
};

const deleteAusenciasDuck = createDuck("DELETE_AUSENCIAS", newActions, newReducers);

const deleteAusenciasThunk = (data) => {
  let url = `${baseUrl}/deleteAusencias`;
  return createThunk(axios, "post", deleteAusenciasDuck.actions, url, data);
};


export default {
  duck,
  getAusenciasThunk,
  createAusenciaDuck,
  createAusenciaThunk,
  deleteAusenciaDuck,
  deleteAusenciaThunk,
  deleteAusenciasDuck,
  deleteAusenciasThunk

};
